export enum TipoTransacao {
  RECEITA = 'RECEITA',
  DESPESA = 'DESPESA',
  TRANSFERENCIA = 'TRANSFERENCIA',
  CAMBIO = 'CAMBIO',
  VENDA = 'VENDA',
  DEVOLUCAO = 'DEVOLUCAO',
  COMPRA = 'COMPRA',
  DEVOLUCAO_DE_COMPRA = 'DEVOLUCAO_DE_COMPRA',
}
